import { postJSON } from './httpService.js';
const CONSULT_STORAGE_KEY = 'vg.client.consult';

export const updateConsultState = (payload) => {
  let consultState = getStoredState(CONSULT_STORAGE_KEY);
  consultState = { ...consultState, ...payload };
  localStorage.setItem(CONSULT_STORAGE_KEY, JSON.stringify(consultState));
};

export const emptyConsultState = () => {
  localStorage.setItem(CONSULT_STORAGE_KEY, JSON.stringify({}));
};

const getStoredState = () => {
  try {
    let localState = JSON.parse(localStorage.getItem(CONSULT_STORAGE_KEY));
    return localState;
  } catch {
    return {};
  }
};

export const getConsultState = () => getStoredState();

export const createRequestForNewConsult = (consult) =>
  postJSON(`/client/consult`, consult);
